import { h, Component } from 'preact';
import classNames from 'classnames';
import styles from './form_field_style';

let cx = classNames.bind(styles);

export default class FormField extends Component {
	updateValue = (newValue) => {
		console.log([this.props.field.mapping, newValue]);
		this.props.validateAndStoreField(this.props.field.mapping, newValue);
	}
	renderField = (field, responses) => {
		return this.props.fieldTypeRenderer.renderField(this.updateValue.bind(this), field,responses);
	}
	renderValidationMessages = (field, responses) => {
		if (responses[field.mapping].validationErrors.length === 0) return null;
		const validationMessage = responses[field.mapping].validationErrors.reduce((tracer,validation) => { return tracer + " " + validation.message; }, "");
		return (
			<div class="invalid-feedback">
				{ validationMessage }
			</div>
		);
	}
	render({field, responses}, {}) {
		var sizeClass = cx([
			{
				field: true,
				Small: field.size === 'Small',
				Medium: field.size === 'Medium',
				Large: field.size === 'Large',
				XLarge: field.size === 'XLarge'
			},
			field.customClasses
		]);
		return (
			<div class={sizeClass}>
        		<label for={field.mapping}>{field.label}</label>
        		{this.renderField(field, responses)}
				{this.renderValidationMessages(field, responses)}
      		</div>
		);
	}
}



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/form_field.js